export default "__VITE_ASSET__X3GB0x3J__"